// Supabase auth storage adapter.
//
// HIPAA posture (Doc 4): "JWT must be stored in memory only" — pure
// memory storage was the original implementation, but it broke any
// redirect-based flow (Stripe Checkout, Stripe Billing Portal, browser
// back button to a deep link). Full-page redirects necessarily blow
// away in-memory state.
//
// Compromise: sessionStorage. Per-tab, automatically cleared when the
// tab/browser closes, never shared across origins. Stricter than the
// default localStorage (which survives reboots and is shared across
// tabs on the same origin). The PKCE code_verifier already lived here.
//
// Doc 4 deviation logged in BLOCKERS.md — revisit if HIPAA review
// requires we move back to memory-only and we route around redirects
// via Stripe Elements (in-app) instead of Checkout.

const NOOP = {
  getItem: () => null,
  setItem: () => undefined,
  removeItem: () => undefined,
} as const;

function backingStore(): {
  getItem: (k: string) => string | null;
  setItem: (k: string, v: string) => void;
  removeItem: (k: string) => void;
} {
  if (typeof window === 'undefined') return NOOP;
  try {
    return window.sessionStorage;
  } catch {
    return NOOP;
  }
}

export const memorySessionStorage = {
  getItem(key: string): string | null {
    return backingStore().getItem(key);
  },
  setItem(key: string, value: string): void {
    backingStore().setItem(key, value);
  },
  removeItem(key: string): void {
    backingStore().removeItem(key);
  },
};
